import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import ListingContainer from "../../containers/listing_container";
import {COMPANY_API_URL} from "../../constants/api_routes";
import ViewCompanyDetails from "./view_company_details";
import CreateCompany from "./create_company";
import UpdateCompany from "./update_company";
import {Button, Header, Icon, Modal, Popup,Image,Form,Segment} from "semantic-ui-react";
import Loader from "../universal/loader";
import * as noLogo from "../../assets/placeholderImage.png";
import {uploadCompanyLogo} from "../../data/user_api";

class Company extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: 'listing',
            showConfirm: false,
            userDeleteSelectedId: null,
            selectedCompany:undefined,
            logo:undefined,
            uploadingLogo:false
        }
    }

    componentWillMount() {
        this.setState({action: 'listing'});
        this.props.getList(COMPANY_API_URL);
    }

    handleView = (row) => {
        this.setState({action: 'view'});
        this.props.viewDetails(this.props.companyData.filter((e) => {
            return e.id === row;
        }));
    };

    handleEdit = (row) => {
        this.setState({action: 'update'});
        this.props.editDetails(this.props.companyData.filter((e) => {
            return e.id === row;
        }));
    };

    handlePriceView = (row) => {
        this.props.history.push('/company/price_list/' + row);
    };


    handleCreate = () => {
        this.setState({action: 'create'});
    };

    handleDelete = (row) => {
        this.props.deleteDetail(COMPANY_API_URL, row);
        this.setState({showConfirm: false});
    };

    handleClose = () => {
        this.setState({action: 'listing'});
    };

    handleLogoUpload = (e) => {
        e.preventDefault();
        this.setState({uploadingLogo:true});
        const formData = new FormData(e.target);
        uploadCompanyLogo(formData).then((response)=>{
            if(response.success){
                this.handleClose();
            }
        })
    };

    render() {
        const columns = [{
            Header: 'Company Name',
            accessor: 'name',
            filterable: true
        }, {
            Header: 'Contact Email',
            accessor: 'email',
            filterable: true
        }, {
            Header: 'Phone Number',
            accessor: 'phone_number',
            filterable: true,
        }, {
            Header: 'Address',
            className:'caddress-width left-aligned',
            headerClassName:'caddress-width',
            accessor: 'address',
            filterMethod: (filter, row) => {
                const id = filter.pivotId || filter.id;
                return row[id] !== undefined ? String(row[id]).replace(/[^\w]/g,'').toUpperCase().indexOf(filter.value.replace(/[^\w]/g,'').toUpperCase()) >= 0 : true
            },
            filterable: true
        }, {
            Header: 'Action',
            id: 'edit',
            className:'center-aligned',
            accessor: 'id',
            minWidth: 150,
            Cell: ({original,value}) => (
                <div>{original.depositary_client_token &&<Popup trigger={<Button basic compact icon positive size='mini' ><Icon
                name='home' />Depositary</Button>}>                        {original.linked_depositary_branches && <div>
                    <h4>Linked Branches</h4>
                    <ul>
                        {original.linked_depositary_branches.map((branch) => { return <li key={branch}>{branch}</li> })}
                    </ul></div>}</Popup>}
                    <Button basic compact icon positive size='mini' onClick={(e) => this.handleView(value)}><Icon
                        name='eye'/>View</Button>
                    <Button basic compact icon primary size='mini' onClick={(e) => this.handleEdit(value)}><Icon
                        name='edit'/>Edit</Button>
                    <Button basic compact icon color="teal" size='mini' onClick={(e) => this.setState({action:'uploadLogo',selectedCompany:value,logo:original['logo_path']})}><Icon
                        name='edit'/>Logo</Button>
                    <Popup
                        trigger={<Button basic compact icon negative size='mini'><Icon name='user delete'/></Button>}
                        content={<Button negative content='Confirm Remove Company?'
                                         onClick={(e) => this.handleDelete(value)}/>}
                        on='click'
                        position='right center'
                        hideOnScroll
                    />
                </div>
            )
        }];
        return (<div className="listing-container pad-top">
                <div style={{display:'flex'}} className="pad-bottom">
                    <div>
                        <Header content="Companies" size='large' textAlign="left"/>
                    </div>
                    <div style={{marginLeft:'1%'}}>
                    <Button primary icon labelPosition='right' onClick={(e) => {
                        this.handleCreate()
                    }}>Add New Company <Icon name='plus'/>
                    </Button>
                    </div>
                </div>
                <div>
                    {this.props.isFetching && <Loader/>}
                    {!this.props.isFetching && this.props.companyData.length > 0 && <ReactTable
                        data={this.props.companyData}
                        columns={columns}
                        defaultFilterMethod={(filter, row, column) => {
                            const id = filter.pivotId || filter.id;
                            return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                        }}
                        defaultPageSize={10}
                        minRows={0}
                    />}

                    <Modal size={this.state.action === 'uploadLogo'?"tiny":"large"} open={this.state.action !== "listing"} onClose={(e) => {
                        this.setState({action: "listing"})
                    }}>
                        <Modal.Content>
                            <div className="modal-close-button">
                            <Button basic icon negative onClick={(e) => {
                                this.setState({action: "listing"})
                            }}><Icon name="close"/></Button>
                            </div>
                            <Modal.Description>
                                {this.state.action === 'view' &&
                                <ViewCompanyDetails selectedObject={this.props.selectedObject} priceView={(id) => this.handlePriceView(id)}/>}
                                {this.state.action === 'update' &&
                                <UpdateCompany selectedObject={this.props.selectedObject} close={this.handleClose}/>}
                                {this.state.action === 'create' && <CreateCompany close={this.handleClose}/>}
                                {this.state.action === 'uploadLogo' && <div>
                                    <Header size="large" content="Company Logo"/>
                                    <div className="nested-listing-container pad-all">
                                        <Segment style={{minHeight:'200px'}}>
                                        <Image src={this.state.logo?this.state.logo:noLogo} size="medium" rounded centered/>
                                        </Segment>
                                        <div className="pad-top">
                                            <Form onSubmit={this.handleLogoUpload}>
                                                <input type="hidden" name="id" value={this.state.selectedCompany} />
                                                <Form.Input type="file" name="logo" label="New Logo"/>
                                                <div className="right-aligned">
                                                <Button content="Cancel" type="button" disabled={this.state.uploadingLogo} onClick={(e) => {this.setState({action: "listing"})}}/>
                                                <Button primary content={this.state.uploadingLogo?"Uploading Please Wait...":"Update Logo"} disabled={this.state.uploadingLogo}/>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>}
                            </Modal.Description>
                        </Modal.Content>
                    </Modal>
                    {!this.props.isFetching && (this.props.companyData.length < 1) &&
                    <div className='center'>No Available Companies. Add new company?</div>}
                </div>
            </div>

        );
    }

}

export default ListingContainer(Company);


// WEBPACK FOOTER //
// ./src/views/company/index.js